var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      staticClass: "flex flex--directionColumn flex-s--directionColumnReverse",
    }),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "continent-worldwide-tab" } },
      [
        [
          _c(
            "ul",
            {
              staticClass:
                "flex xmoCountryList width100 flex margin-vertical-20",
            },
            [
              _vm._l(_vm.regions.countries, function (country, countryIndex) {
                return [
                  _c(
                    "li",
                    {
                      key: countryIndex,
                      staticClass: "xmoCountryList__item flex__item width20",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "xmoCountryList__link",
                          attrs: {
                            href: `/outlook/${country.slug}`,
                            "data-gtm": `xmoCO__countryId${country.id}`,
                          },
                        },
                        [
                          _c("img", {
                            staticClass:
                              "xmoNavigationOverlay__listItemIcon pos-relative margin-right-5 lazy",
                            attrs: {
                              src: _vm.getCdnLink("icons/blank.gif"),
                              "data-src": _vm.getCdnLink(
                                `icons/flag/iso/16/${country.isoCode}.png`
                              ),
                              alt: country.name,
                              height: "16px",
                              width: "16px",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(country.name))]),
                        ]
                      ),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }